import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useLang } from "./LanguageContext";
import Seo from "./components/Seo";
import { HOME_SEO, ORGANIZATION_JSONLD, SITE_URL } from "./seoConfig";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Intro from "./components/Intro";
import Collections from "./components/Collections";
import Featured from "./components/Featured";
import Defense from "./components/Defense";
import Heritage from "./components/Heritage";
import Partners from "./components/Partners";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ProductModal from "./components/ProductModal";
import Loader from "./components/Loader";

const Home = () => {
  const location = useLocation();
  const { loading, lang } = useLang();
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    if (!loading && location.hash) {
      const id = location.hash.replace("#", "");
      const timer = setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 400);
      return () => clearTimeout(timer);
    }
  }, [location, loading]);

  if (loading) return <Loader />;

  const s = HOME_SEO[lang] || HOME_SEO.sv;
  const websiteJsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Horns Industriservice AB",
    url: SITE_URL,
  };

  return (
    <>
      <Seo title={s.title} description={s.description} keywords={s.keywords} path="/" lang={lang}
        jsonLd={[ORGANIZATION_JSONLD, websiteJsonLd]} />
      <Header />
      <main>
        <Hero />
        <Intro />
        <Collections onOpen={setOpenId} />
        <Featured />
        <Defense />
        <Heritage />
        <Partners />
        <Contact />
      </main>
      <Footer />
      <ProductModal openId={openId} onClose={() => setOpenId(null)} />
    </>
  );
};

export default Home;
